import { apiService } from '@/services/APIService';

export default {

  login(params) {
    return apiService.post('/login', params);
  },
  authCode(params) {
    return apiService.post('/auth-code', params);
  },
};
